<template>
  <div class="hello" @mouseover="mouseIn" @mouseout="mouseO">
    <div :style="containerStyle">
      <div :style="ulStyle" ref="box">
        <div v-for="(item , index) in imgData" :key="index" :style="liStyle">
          <a :href="item.url" target="_blank" style="display:block">
            <img :src="item.img" alt :style="imgStyle" />
          </a>
          <div :style="txtStyle">{{item.title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hello",
  props: {
    type: {
      type: String,
      default: "top",
    },
    speed: {
      type: Number,
      default: 20,
    },
    imgData: {
      type: Array,
    },
    margin: {
      type: String,
      default: "20px",
    },
    txtPos: {
      type: Array,
      default: ["10%", "10%"],
    },
  },
  data() {
    return {
      containerStyle: {
        width: "",
        height: "",
        overflow: "hidden",
        zIndex: 999,
        position: "relative",
      },
      ulStyle: {
        position: "absolute",
        top: "0",
        height: "100%",
        width: "",
        left: '0'
      },
      imgStyle: {
        width: "",
        height: "",
        // display: block,
        // zIndex: 9999
      },
      liStyle: {
        float: "left",
        width: "",
        height: "100%",
        position: "relative",
        paddingLeft: "20px",
        textAlign: "center",
        paddingTop: "10px",
      },
      txtStyle: {
        // position: "absolute",
        // bottom: "20px",
        // left: "20px",
        margin: '10px auto',
        zIndex: "10000",
      },
      timer: {},
      // img_data: {},
    };
  },
  watch: {
   
  },
  created() {
    // let arr = [];
    // this.imgData.forEach((item) => {
    //   arr.push(item);
    // });
    // console.log(this.imgData);
    // this.imgData.forEach((item) => {
    //   arr.push(item);
    // });
    // this.img_data = arr;
    this.containerStyle.width = "260px";
    this.containerStyle.height = "220px";
    this.ulStyle.height = "100%";
    this.ulStyle.width = "100%";
    this.imgStyle.width = "260px";
    this.imgStyle.height = "50px";

    this.txtStyle.left = this.txtPos[0];
    this.txtStyle.bottom = this.txtPos[1];
    if (this.type === "left") {
      this.liStyle.paddingTop = "0";
      this.containerStyle.width = "1200px";
      this.containerStyle.height = "220px";
      this.containerStyle.marginTop = "20px";
      this.imgStyle.width = "200px";
      this.imgStyle.height = "140px";
    } else {
      this.liStyle.width = "100%";
      this.liStyle.height = "auto";
      this.liStyle.paddingLeft = "0";
    }

  },
  mounted() {
    this.trans(this.type);
  },
  methods: {
    trans(type) {
      let _this = this;
      let allImgLength;
      if (type === "left") {

        allImgLength = this.imgData.length * this.$el.clientWidth;
        console.log(allImgLength);
        this.ulStyle.width = allImgLength + "px";
        this.timer = setInterval(function () {
        let num = 0;
        try {
          num = Number(_this.$refs.box.style[type].replace("px", ""));
          if (num <= -allImgLength / 10) {
            num = 0;
          }
          _this.$refs.box.style[type] = num - 1 + "px";
        } catch (e) {}
      }, this.speed);
      } else {
        allImgLength = this.imgData.length * this.$el.clientHeight;
        this.ulStyle.height = allImgLength + "px";
        this.timer = setInterval(function () {
        let num = 0;
        try {
          num = Number(_this.$refs.box.style[type].replace("px", ""));
          if (num <= -allImgLength / 2) {
            num = 0;
          }
          _this.$refs.box.style[type] = num - 1 + "px";
        } catch (e) {}
      }, this.speed);
      }
    },
    mouseIn() {
      clearInterval(this.timer);
    },
    mouseO() {
      this.trans(this.type);
    },
  },
};
</script>

<style scoped>
/* .imgStyle {
    width: 260px;
    height: 50px;
    display: block;
    z-index: 9999
  } */
</style>


// WEBPACK FOOTER //
// src/components/VueImgSlider.vue